import toast from "react-hot-toast";
import { QueryClient, useMutation } from "@tanstack/react-query";
import { updateV3CollectionRules } from "../../../api/collections";
import { V3GenericErrorHandler } from "../../../api/error-handler";
import { getV3CollectionRulesKey } from "../../../types/queries";

// Update collection rules mutation
export const getUpdateCollectionRulesMutation = (queryClient: QueryClient, token: string) =>
    useMutation({
        mutationFn: updateV3CollectionRules,
        onError: V3GenericErrorHandler(toast.error),
        onSuccess: async (data, variables) => {
            queryClient.setQueryData(getV3CollectionRulesKey(token!, variables.userSlug, variables.collectionId), data);
        }
    });
